import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from 'modules/CustomersAndRestaurants/Customers/CustomerFullInfo/customerFullInfoState/customerFullInfoContext';
import React, { useContext, useEffect, useReducer } from 'react';
import { pushesViewReducer } from './pushesViewReducer';
import { AppContext, IAppContext } from 'appState/appContext';
import { PushesViewContext, pushesViewInitialState, TPushesViewSortBy, TTypeOfModalWindow } from './pushesViewContext';
import {
	TCountOfItems,
	IItemForGetShortInfoWithStatus,
	IGetPaginatedCustomerSoftwareUpdates,
	RestaurantNotificationEventType,
	ISoftwareUpdates,
} from 'types';
import { PushesViewActionTypes } from '../pushesViewActions';
import { AxiosResponse } from 'axios';
import { useFetchData } from 'hooks/useFetchData';
import { getPaginatedCustomerSoftwareUpdates } from 'backend/customers';

const PushesViewState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(pushesViewReducer, pushesViewInitialState);
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	// const { refetch, response, loading } = useFetchData<
	// 	AxiosResponse<ISoftwareUpdates>,
	// 	IGetPaginatedCustomerSoftwareUpdates
	// >(customerForFullInfo?.id ? getPaginatedCustomerSoftwareUpdates : null, {
	// 	customerId: customerForFullInfo?.id || '',
	// 	pageNumber: state.currentPage,
	// 	pageSize: Number(state.countOfItems),
	// 	searchByName: state.searchString ? state.searchString : null,
	// 	sortName: state.sortBy === 'Name1-10' || state.sortBy === 'Name10-1' ? state.sortBy : null,
	// 	sortLastUpdateDate:
	// 		state.sortBy === 'LastUpdate1-10' || state.sortBy === 'LastUpdate10-1' ? state.sortBy : null,
	// 	sortUpdateBy: state.sortBy === 'UpdatedByA-Z' || state.sortBy === 'UpdatedByZ-A' ? state.sortBy : null,
	// 	sortSoftwareType:
	// 		state.sortBy === 'SoftwareTypeA-Z' || state.sortBy === 'SoftwareTypeZ-A' ? state.sortBy : null,
	// }); TODO need to add on BE

	// useEffect(() => {
	// 	loading ? showLoader() : hideLoader();
	// }, [loading]); TODO need to add on BE

	// useEffect(() => {
	// 	if (response) {
	// 		dispatch({
	// 			type: PushesViewActionTypes.SET_SOFTWARE_UPDATES,
	// 			payload: {
	// 				softwareUpdates: response.data,
	// 			},
	// 		});
	// 	}
	// }, [response]); TODO need to add on BE

	const changeSearchString = (value: string) => {
		dispatch({
			type: PushesViewActionTypes.CHANGE_SEARCH_STRING,
			payload: {
				searchString: value,
			},
		});
	};

	const setSortBy = (sortBy: TPushesViewSortBy) => {
		dispatch({
			type: PushesViewActionTypes.SET_SORT_BY,
			payload: {
				sortBy: sortBy,
			},
		});
	};

	const setCountOfItems = (count: TCountOfItems) => {
		dispatch({
			type: PushesViewActionTypes.SET_COUNT_OF_ITEMS,
			payload: {
				countOfItems: count,
			},
		});
	};

	const changeCurrentPage = (page: number) => {
		dispatch({
			type: PushesViewActionTypes.CHANGE_CURRENT_PAGE,
			payload: {
				currentPage: page,
			},
		});
	};

	const setFetchedRestaurants = (value: IItemForGetShortInfoWithStatus[]) => {
		dispatch({
			type: PushesViewActionTypes.SET_FETCHED_RESTAURANTS,
			payload: {
				fetchedRestaurants: value,
			},
		});
	};

	const setRestaurantsForPush = (value: string[]) => {
		dispatch({
			type: PushesViewActionTypes.SET_RESTAURANTS_FOR_PUSH,
			payload: {
				restaurantsForPush: value,
			},
		});
	};

	const setPushCallback = (value: ((restaurantsForPush: string[]) => Promise<void>) | null) => {
		dispatch({
			type: PushesViewActionTypes.SET_PUSH_CALLBACK,
			payload: {
				pushCallback: value,
			},
		});
	};

	const changeTypeOfModalWindow = (value: TTypeOfModalWindow) => {
		dispatch({
			type: PushesViewActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	};

	// useEffect(() => {
	// 	refetch(); TODO need to add on BE
	// }, [state.currentPage, state.countOfItems, state.searchString, state.sortBy, customerForFullInfo?.id]);

	return (
		<PushesViewContext.Provider
			value={{
				changeSearchString,
				setSortBy,
				setCountOfItems,
				changeCurrentPage,
				setFetchedRestaurants,
				setRestaurantsForPush,
				setPushCallback,
				changeTypeOfModalWindow,
				softwareUpdates: state.softwareUpdates,
				searchString: state.searchString,
				sortBy: state.sortBy,
				countOfItems: state.countOfItems,
				currentPage: state.currentPage,
				fetchedRestaurants: state.fetchedRestaurants,
				restaurantsForPush: state.restaurantsForPush,
				pushCallback: state.pushCallback,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</PushesViewContext.Provider>
	);
};

export default PushesViewState;
